module.exports = __webpack_public_path__ + "img/panel_feature_1_500X.57bce004.jpg";